// src/components/PWAInstallBanner.js
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePWAInstall from '../hooks/usePWAInstall';

export default function PWAInstallBanner() {
  const { isInstallable, isIOS, isInstalled, triggerInstall } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Only show on /dashboard (right after login)
  const isDashboard = location.pathname === '/dashboard';

  // Show banner with a short delay after reaching dashboard so the page
  // has time to render first — feels more natural than instant pop-up
  useEffect(() => {
    if (!isDashboard) return;
    if (isInstalled || dismissed) return;
    if (!isInstallable && !isIOS) return;

    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, [isDashboard, isInstalled, dismissed, isInstallable, isIOS]);

  // Hide when navigating away from dashboard
  useEffect(() => {
    if (!isDashboard) setVisible(false);
  }, [isDashboard]);

  if (!visible) return null;

  return (
    <div className="pwa-banner" role="banner" aria-label="Install app">
      <div className="pwa-banner-content">
        <img src="/favico.png" alt="Meeting.Training app icon" className="pwa-banner-icon" />
        <div className="pwa-banner-text">
          <strong>Install Meeting.Training</strong>
          {isIOS ? (
            <span>
              Tap <span className="pwa-share-icon">⬆</span> Share →{' '}
              <strong>"Add to Home Screen"</strong>
            </span>
          ) : (
            <span>Add to your home screen for quick access</span>
          )}
        </div>
      </div>
      <div className="pwa-banner-actions">
        {!isIOS && (
          <button
            className="btn btn-primary btn-sm"
            onClick={async () => {
              await triggerInstall();
              setVisible(false);
            }}
          >
            Install
          </button>
        )}
        <button
          className="btn-ghost"
          onClick={() => {
            setDismissed(true);
            setVisible(false);
          }}
          aria-label="Dismiss install prompt"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
